const RMBoxIntegrated = ({language , token}) => {
    const newRMBoxIframe = "https:" +
    window.process.env.URL_Boitier_Rmbox
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_RMBox_display"
        src={newRMBoxIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default RMBoxIntegrated